/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';

// TYPES

const types = {
  SHOW_SECTION: 'app/systemNotification/SHOW_SECTION',
};

const initialState = {
  appMenu: {
    sectionType: 'main',
    isVisible: false,
  },
};

// REDUCER

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.SHOW_SECTION:
      return _.assign({}, state, {
        appMenu: { ...state.appMenu, ...action.payload },
      });
    default:
      return state;
  }
}

// SELECTORS

export const selectors = {
  isSectionVisible: state => state.ui.appMenu.isVisible,
  currentSection: state => state.ui.appMenu.sectionType,
};

// ACTION CREATORS

export const actions = {
  showHelpSection: () => {
    return {
      type: types.SHOW_SECTION,
      payload: {
        sectionType: 'help',
        isVisible: true,
      },
    };
  },

  showProfileSection: () => {
    return {
      type: types.SHOW_SECTION,
      payload: {
        sectionType: 'profile',
        isVisible: true,
      },
    };
  },

  closeSection: () => {
    return {
      type: types.SHOW_SECTION,
      payload: {
        isVisible: false,
        sectionType: 'main',
      },
    };
  },

};


// THUNK ACTION CREATORS
